import { render, staticRenderFns } from "./EditAdmin.vue?vue&type=template&id=56a0a8c8&scoped=true"
import script from "./EditAdmin.vue?vue&type=script&lang=js"
export * from "./EditAdmin.vue?vue&type=script&lang=js"
import style0 from "./EditAdmin.vue?vue&type=style&index=0&id=56a0a8c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a0a8c8",
  null
  
)

export default component.exports